import { useMutation, useQueryClient } from '@tanstack/react-query';
import { joinKeyQueryKeys, JoinKeys } from '#api';

export function useDeleteJoinKeyMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (joinKeyID: string) => JoinKeys.deleteJoinKey(joinKeyID),
    onSuccess: (data, joinKeyID) => {
      queryClient.removeQueries({ queryKey: joinKeyQueryKeys.detail(joinKeyID), exact: true });
      void queryClient.invalidateQueries({ queryKey: joinKeyQueryKeys.lists() });
    },
  });
}
